import { render, staticRenderFns } from "./RootComponent.vue?vue&type=template&id=10da4286"
import script from "./RootComponent.vue?vue&type=script&lang=js"
export * from "./RootComponent.vue?vue&type=script&lang=js"
import style0 from "./RootComponent.vue?vue&type=style&index=0&id=10da4286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports